import React, { useState } from 'react';
import styled, { keyframes, css } from 'styled-components';
import FlexContainer from '@/components/molecules/FlexContainer';
import Item from '@/components/atoms/UI/Item/Item';
import DeleteButton from '@/components/atoms/DeleteButton/DeleteButton';

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-10px);
  }
`;

export const AnimatedItem = styled(Item)<{ isVisible: boolean }>`
  transition: opacity 0.3s ease, transform 0.3s ease;
  ${({ isVisible }) =>
	!isVisible &&
	css`
      animation: ${fadeOut} 0.3s forwards;
    `}
`;

interface DomainItemProps {
	domain: string;
	onDelete: () => Promise<boolean>;
	isDeletable?: boolean;
}

const DomainItem: React.FC<DomainItemProps> = ({ domain, onDelete, isDeletable }) => {
	const [isVisible, setIsVisible] = useState(true); // Управляем видимостью
	const [isDeleting, setIsDeleting] = useState(false); // Управляем состоянием удаления

	const handleDelete = async () => {
		setIsDeleting(true);
		setIsVisible(false);

		const success = await onDelete();

		setTimeout(() => {
			if (success) {
				setIsDeleting(false);
			} else {
				setIsVisible(true);
				setIsDeleting(false);
			}
		}, 300);
	};

	return (
		<AnimatedItem isVisible={isVisible}>
			<FlexContainer gap="1" stretchAutoWidth>
				<div>{domain}</div>
				{isDeletable ? <DeleteButton onClick={handleDelete} disabled={isDeleting} /> : <div></div>}
			</FlexContainer>
		</AnimatedItem>
	);
};

export default DomainItem;
